import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function DangerTriangle({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <DangerTriangle.Outline {...props} />
  ) : (
    <DangerTriangle.Solid {...props} />
  );
}

DangerTriangle.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M12.0024 9.5647C12.4167 9.5647 12.7524 9.90048 12.7524 10.3147V13.4147C12.7524 13.8289 12.4167 14.1647 12.0024 14.1647C11.5882 14.1647 11.2524 13.8289 11.2524 13.4147V10.3147C11.2524 9.90048 11.5882 9.5647 12.0024 9.5647Z"
          fill="currentColor"
        />
        <path
          d="M11.9951 15.5C11.4428 15.5 10.9951 15.9477 10.9951 16.5C10.9951 17.0523 11.4428 17.5 11.9951 17.5H12.0051C12.5574 17.5 13.0051 17.0523 13.0051 16.5C13.0051 15.9477 12.5574 15.5 12.0051 15.5H11.9951Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.57218 4.41394C10.6525 2.52768 13.3722 2.52921 14.451 4.41539L21.637 16.9803C22.7091 18.8547 21.3545 21.1868 19.197 21.1868H4.81396C2.65472 21.1868 1.30204 18.8531 2.37396 16.9793L9.57218 4.41394ZM13.1489 5.16009C12.6457 4.28032 11.3775 4.27983 10.8738 5.15946L3.67597 17.7242C3.17588 18.5984 3.80721 19.6868 4.81396 19.6868H19.197C20.2034 19.6868 20.8347 18.5988 20.335 17.7252L13.1489 5.16009Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

DangerTriangle.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M4.7227 21.1672C4.7097 21.1672 4.6977 21.1672 4.6837 21.1662C4.3687 21.1502 4.0597 21.0822 3.7657 20.9632C2.3187 20.3752 1.6207 18.7222 2.2077 17.2762L9.5287 4.45025C9.7807 3.99425 10.1627 3.61225 10.6287 3.35425C11.9937 2.59825 13.7197 3.09525 14.4747 4.45925L21.7477 17.1872C21.9097 17.5682 21.9787 17.8782 21.9957 18.1942C22.0347 18.9502 21.7767 19.6752 21.2707 20.2362C20.7647 20.7972 20.0697 21.1282 19.3147 21.1662L4.7947 21.1672H4.7227Z"
          className="icon-secondary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1245 10.0208C11.1245 9.53875 11.5175 9.14575 11.9995 9.14575C12.4815 9.14575 12.8745 9.53875 12.8745 10.0208V12.8488C12.8745 13.3318 12.4815 13.7238 11.9995 13.7238C11.5175 13.7238 11.1245 13.3318 11.1245 12.8488V10.0208ZM11.1245 16.2699C11.1245 15.7849 11.5175 15.3899 11.9995 15.3899C12.4815 15.3899 12.8745 15.7799 12.8745 16.2589C12.8745 16.7519 12.4815 17.1449 11.9995 17.1449C11.5175 17.1449 11.1245 16.7519 11.1245 16.2699Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
